import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FiEye,
  FiChevronRight,
  FiChevronLeft,
  FiHome,
  FiX,
  FiImage,
  FiMoreVertical,
  FiCheck,
  FiXCircle,
} from "react-icons/fi";
import toast from "react-hot-toast";

import { getJoiningPaymentList, approveRejectJoiningPayment } from "../../store/slices/profile";

const PackageRequest = () => {
  const dispatch = useDispatch();

  const [selectedImage, setSelectedImage] = useState(null);
  const [openAction, setOpenAction] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(25);
  const {
    joiningPaymentList = [],
    joiningPaymentListLoading,
    joiningPaymentCount = 0,
    joiningPaymentActionLoading,
    error,
  } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(
      getJoiningPaymentList({
        status: "PENDING",
        page,
        limit,
      })
    );
  }, [dispatch, page, limit]);

  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };


  const handlePaymentAction = async (transactionId, action) => {
    try {
      const response = await dispatch(
        approveRejectJoiningPayment({
          transactionId,
          action,
        })
      ).unwrap();

      // Success toast
      toast.success(
        response?.message ||
        `Payment ${action === "APPROVE" ? "approved" : "rejected"} successfully`
      );

      setOpenAction(null);

      // Refresh pending payment list
      dispatch(
        getJoiningPaymentList({
          status: "PENDING",
          page,
          limit,
        })
      );
    } catch (error) {
      console.error("Payment action failed:", error);

      // Error toast
      toast.error(
        error?.message ||
        error?.error?.message ||
        "Failed to process payment action"
      );
    }
  };

  const closeImageViewer = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gi-referral-page">

      <div className="gi-breadcrumb">

        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Package Request
        </span>
        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Pending Package Request
        </span>

      </div>

      <section className="gi-referral-table-card">
        <div className="gi-referral-table-wrapper">

          <table className="gi-referral-table">

            <thead>
              <tr>
                <th>#</th>

                <th>
                  Name
                </th>

                <th className="text-center">
                  User ID
                </th>

                <th className="text-center">
                  Transaction ID
                </th>

                <th className="text-center">
                  Amount
                </th>

                <th className="text-center">
                  Payment Image
                </th>

                <th className="text-center">
                  Date
                </th>

                <th className="text-center">
                  Status
                </th>

                <th className="text-center">
                  Action
                </th>
              </tr>
            </thead>


            <tbody>

              {joiningPaymentListLoading && (

                <tr>

                  <td
                    colSpan="9"
                    className="gi-table-message"
                  >
                    Loading payments...
                  </td>

                </tr>

              )}

              {!joiningPaymentListLoading && error && (

                <tr>

                  <td
                    colSpan="9"
                    className="gi-table-message"
                  >
                    {error}
                  </td>

                </tr>

              )}


              {!joiningPaymentListLoading &&
                !error &&
                joiningPaymentList.length === 0 && (

                  <tr>

                    <td
                      colSpan="9"
                      className="gi-table-message"
                    >
                      No pending package request found!
                    </td>

                  </tr>

                )}

              {!joiningPaymentListLoading &&
                !error &&
                joiningPaymentList.map((item, index) => {

                  const user = item.userId || {};

                  const status =
                    item.status ||
                    "PENDING";

                  return (

                    <tr
                      key={item._id || index}
                    >
                      <td>
                        {String((page - 1) * limit + index + 1).padStart(2, "0")}
                      </td>


                      <td>
                        {user.name || "-"}

                      </td>


                      <td className="text-center">

                        <span >

                          {user.userId || "-"}

                        </span>

                      </td>


                      <td className="text-center">

                        <span >

                          {item.trn || "-"}

                        </span>

                      </td>


                      <td className="text-center">

                        <strong className="gi-payment-amount">

                          ${item.amount || 0}

                        </strong>

                      </td>

                      <td className="text-center">

                        {item.trnImage ? (

                          <button
                            type="button"
                            className="gi-view-image-btn"
                            onClick={() =>
                              setSelectedImage({
                                url: item.trnImage,
                                userName: user.name,
                                transactionId: item.transactionId,
                              })
                            }
                          >
                            <FiEye />
                          </button>

                        ) : (

                          <span className="gi-no-image">

                            No Image

                          </span>

                        )}

                      </td>

                      <td className="text-center">

                        <span className="gi-date-text">

                          {formatDate(item.createdAt)}

                        </span>

                      </td>

                      <td className="text-center">

                        <span
                          className={`gi-status-badge ${status.toLowerCase()}`}
                        >


                          {status}
                        </span>

                      </td>

                      <td className="text-center">

                        {status === "PENDING" ? (

                          <div className="gi-payment-action-wrap">

                            <button
                              type="button"
                              className="gi-payment-action-btn"
                              onClick={() =>
                                setOpenAction(
                                  openAction === item._id
                                    ? null
                                    : item._id
                                )
                              }
                            >
                              <FiMoreVertical />
                            </button>


                            {openAction === item._id && (

                              <div className="gi-payment-action-menu">

                                <button
                                  type="button"
                                  className="gi-action-approve"
                                  disabled={joiningPaymentActionLoading}
                                  onClick={() =>
                                    handlePaymentAction(
                                      item._id,
                                      "APPROVE"
                                    )
                                  }
                                >
                                  <FiCheck />

                                  Approve
                                </button>


                                <button
                                  type="button"
                                  className="gi-action-reject"
                                  disabled={joiningPaymentActionLoading}
                                  onClick={() =>
                                    handlePaymentAction(
                                      item._id,
                                      "REJECT"
                                    )
                                  }
                                >
                                  <FiXCircle />

                                  Reject
                                </button>

                              </div>

                            )}

                          </div>

                        ) : (

                          <span className="gi-action-completed">
                            Approved
                          </span>

                        )}

                      </td>

                    </tr>

                  );

                })}

            </tbody>

          </table>

          {/* ================= PAGINATION ================= */}

          {joiningPaymentCount > 0 && (
            <div className="gi-pagination">

              <div className="gi-pagination-info">
                Showing{" "}
                <strong>
                  {(page - 1) * limit + 1}
                </strong>
                {" - "}
                <strong>
                  {Math.min(page * limit, joiningPaymentCount)}
                </strong>
                {" "}of{" "}
                <strong>
                  {joiningPaymentCount}
                </strong>
              </div>

              <div className="gi-pagination-controls">

                <button
                  type="button"
                  disabled={page === 1 || joiningPaymentListLoading}
                  onClick={() => setPage((prev) => prev - 1)}
                >
                  <FiChevronLeft />
                </button>

                <span className="gi-pagination-page">
                  Page {page} of{" "}
                  {Math.ceil(joiningPaymentCount / limit)}
                </span>

                <button
                  type="button"
                  disabled={
                    page >= Math.ceil(joiningPaymentCount / limit) ||
                    joiningPaymentListLoading
                  }
                  onClick={() => setPage((prev) => prev + 1)}
                >
                  <FiChevronRight />
                </button>

              </div>

            </div>
          )}

        </div>

      </section>

      {selectedImage && (

        <div
          className="gi-image-viewer-overlay"
          onClick={closeImageViewer}
        >

          <div
            className="gi-image-viewer-modal"
            onClick={(e) => e.stopPropagation()}
          >

            {/* CLOSE */}

            <button
              type="button"
              className="gi-image-viewer-close"
              onClick={closeImageViewer}
            >

              <FiX />

            </button>


            {/* HEADER */}

            <div className="gi-image-viewer-header">

              <div className="gi-image-viewer-title">

                <div className="gi-image-viewer-icon">

                  <FiImage />

                </div>


                <div>

                  <h3>
                    Payment Proof
                  </h3>

                  <p>
                    {selectedImage.userName || "User"}
                  </p>

                </div>

              </div>

            </div>


            {/* IMAGE */}

            <div className="gi-image-viewer-body">

              <img
                src={selectedImage.url}
                alt="Payment Proof"
              />

            </div>



          </div>

        </div>

      )}

    </div>
  );
};

export default PackageRequest;